(function () {
  function initCopyButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-copy-url]').forEach(function (button) {
      if (button.dataset.copyInit === 'true') return;
      button.dataset.copyInit = 'true';

      button.addEventListener('click', function () {
        var url = button.getAttribute('data-copy-url');
        if (!url) return;

        function markCopied() {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 1500);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(markCopied).catch(function () {
            fallbackCopy(url, markCopied);
          });
          return;
        }

        fallbackCopy(url, markCopied);
      });
    });
  }

  function initShareButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-share-url]:not([data-share-more-toggle])').forEach(function (button) {
      if (button.dataset.shareInit === 'true') return;
      button.dataset.shareInit = 'true';

      button.addEventListener('click', function () {
        var url = button.getAttribute('data-share-url');
        var title = button.getAttribute('data-share-title') || document.title;
        if (!url) return;

        function markShared() {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 1500);
        }

        if (navigator.share) {
          navigator
            .share({ title: title, url: url })
            .then(markShared)
            .catch(function () {
              /* user cancelled */
            });
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(markShared).catch(function () {
            fallbackCopy(url, markShared);
          });
          return;
        }

        fallbackCopy(url, markShared);
      });
    });
  }

  function closeShareMoreMenus(exceptRoot) {
    document.querySelectorAll('[data-share-more]').forEach(function (root) {
      if (exceptRoot && root === exceptRoot) return;

      var menu = root.querySelector('[data-share-more-menu]');
      var toggle = root.querySelector('[data-share-more-toggle]');
      if (!menu || !toggle) return;

      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function initShareMoreButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-share-more]').forEach(function (shareMoreRoot) {
      if (shareMoreRoot.dataset.shareMoreInit === 'true') return;
      shareMoreRoot.dataset.shareMoreInit = 'true';

      var toggle = shareMoreRoot.querySelector('[data-share-more-toggle]');
      var menu = shareMoreRoot.querySelector('[data-share-more-menu]');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var url = toggle.getAttribute('data-share-url');
        var title = toggle.getAttribute('data-share-title') || document.title;
        if (!url) return;

        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {
            /* user cancelled */
          });
          return;
        }

        var isOpen = !menu.hidden;
        closeShareMoreMenus(shareMoreRoot);

        menu.hidden = isOpen;
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });

      menu.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });
  }

  function fallbackCopy(text, onSuccess) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();

    try {
      if (document.execCommand('copy')) onSuccess();
    } catch (error) {
      /* noop */
    }

    document.body.removeChild(input);
  }

  document.addEventListener('click', function () {
    closeShareMoreMenus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeShareMoreMenus();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initCopyButtons(document);
    initShareButtons(document);
    initShareMoreButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initCopyButtons(event.target);
      initShareButtons(event.target);
      initShareMoreButtons(event.target);
    }
  });
})();
